import React from "react";
import { css } from "@emotion/css";
import * as FiIcons from "react-icons/fi";
import SafeIcon from "../../common/SafeIcon";
import { benefitsDesktop } from "../../assets/images";
import { GiUnlocking } from "react-icons/gi";

const { FiUnlock, FiShield, FiZap, FiHeart, FiTool, FiSmile, FiMind } = FiIcons;

const Benefits = () => {
    const benefits = [
        { icon: GiUnlocking, title: "Unlocking Potential" },
        { icon: FiShield, title: "Freedom from Addictions" },
        { icon: FiZap, title: "Increase Energy Efficiency" },
        { icon: FiHeart, title: "Healthy Relationships" },
        { icon: FiTool, title: "Soft Skill Development" },
        { icon: FiSmile, title: "Positive Thinking" },
        { icon: FiMind, title: "Peace of Mind through Stress Relief" },
    ];

    const benefitsStyles = {
        section: css`
            background-color: #f9fafb;
            padding: 3rem 0 2rem;
            margin-bottom: 1rem;
        `,
        container: css`
            max-width: 80rem;
            margin: 0 auto;
            padding: 0 1rem;

            @media (min-width: 640px) {
                padding: 0 1.5rem;
            }

            @media (min-width: 1024px) {
                padding: 0 2rem;
            }
        `,
        headerSection: css`
            text-align: center;
        `,
        title: css`
            font-size: 1.5rem;
            font-weight: bold;
            color: #1f2937;
            margin-bottom: 4px;

            @media (min-width: 640px) {
                font-size: 1.875rem;
                margin-bottom: 32px;
            }

            @media (min-width: 1024px) {
                font-size: 2.25rem;
                margin-bottom: 48px;
            }
        `,
        logoSection: css`
            position: relative;
            display: none;
            justify-content: center;
            align-items: center;
            margin-bottom: 32px;
            min-height: 200px;

            @media (min-width: 640px) {
                margin-bottom: 48px;
                min-height: 300px;
            }

            @media (min-width: 1024px) {
                display: flex;
                margin-bottom: 80px;
                min-height: 400px;
            }
        `,
        centralLogo: css`
            width: 8rem;
            height: 8rem;
            border-radius: 50%;
            overflow: hidden;
            z-index: 10;
            background-color: white;
            box-shadow:
                0 20px 25px -5px rgba(0, 0, 0, 0.1),
                0 10px 10px -5px rgba(0, 0, 0, 0.04);

            @media (min-width: 640px) {
                width: 10rem;
                height: 10rem;
            }

            @media (min-width: 1024px) {
                width: 14rem;
                height: 14rem;
            }
        `,
        logoImage: css`
            width: 100%;
            height: 100%;
            object-fit: cover;
        `,
        benefitsContainerDesktop: css`
            display: flex;
            flex-direction: column;
            padding: 40px;

            @media (max-width: 1024px) {
                display: none;
            }
        `,
        benefitItem: css`
            position: absolute;
            background-color: #ffd965;
            border-radius: 5%;
            padding: 10px;
            box-shadow:
                0 10px 15px -3px rgba(0, 0, 0, 0.1),
                0 4px 6px -2px rgba(0, 0, 0, 0.05);
            transition: all 0.3s;
            cursor: pointer;
            ${"" /* width: 100px; */}
            height: 50px;

            @media (min-width: 640px) {
                padding: 12px;
                ${"" /* width: 100px; */}
                ${"" /* height: 100px; */}
            }

            @media (min-width: 1024px) {
                padding: 14px;
                ${"" /* width: 120px; */}
                ${"" /* height: 70px; */}
            }

            &:hover {
                box-shadow:
                    0 20px 25px -5px rgba(0, 0, 0, 0.1),
                    0 10px 10px -5px rgba(0, 0, 0, 0.04);
                transform: scale(1.1);
            }
        `,
        benefitContent: css`
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            height: 100%;
        `,
        benefitIcon: css`
            background-color: #ffd965;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 5px;

            @media (min-width: 640px) {
                width: 32px;
                height: 32px;
                margin-bottom: 6px;
            }

            @media (min-width: 1024px) {
                width: 40px;
                height: 40px;
                margin-bottom: 7px;
            }
        `,
        icon: css`
            width: 14px;
            height: 14px;
            color: #2563eb;

            @media (min-width: 640px) {
                width: 16px;
                height: 16px;
            }

            @media (min-width: 1024px) {
                width: 20px;
                height: 20px;
            }
        `,
        benefitTitle: css`
            font-weight: 600;
            color: #1f2937;
            font-size: 0.625rem;
            text-align: center;
            line-height: 1.25;

            @media (min-width: 640px) {
                font-size: 0.6875rem;
            }

            @media (min-width: 1024px) {
                font-size: 0.75rem;
            }
        `,
        description: css`
            color: #4b5563;
            margin-bottom: 1.5rem;
            font-size: 0.875rem;
            line-height: 1.5;

            @media (min-width: 640px) {
                margin-bottom: 1.75rem;
                font-size: 0.9375rem;
            }

            @media (min-width: 1024px) {
                margin-bottom: 2rem;
                font-size: 1rem;
            }

            @media (max-width: 768px) {
                ${"" /* text-align: justify; */}
            }
        `,
        // Mobile grid layout for small screens
        mobileBenefitsGrid: css`
            display: grid;
            ${"" /* grid-template-columns: repeat(1, 1fr); */}
            gap: 16px;
            margin-top: 32px;

            @media (min-width: 1024px) {
                display: none;
            }
        `,
        mobileBenefitItem: css`
            background-color: white;
            border-radius: 12px;
            padding: 20px;
            text-align: center;
            box-shadow:
                0 4px 6px -1px rgba(0, 0, 0, 0.1),
                0 2px 4px -1px rgba(0, 0, 0, 0.06);
            transition: all 0.3s;

            &:hover {
                transform: translateY(-2px);
                box-shadow:
                    0 10px 15px -3px rgba(0, 0, 0, 0.1),
                    0 4px 6px -2px rgba(0, 0, 0, 0.05);
            }

            display: grid;
            grid-template-columns: auto 1fr;
            background: bottom;
            background-image: linear-gradient(-45deg, #ffc796 0%, #ff6b95 100%);
            background: #ffe259; /* fallback for old browsers */
            background: -webkit-linear-gradient(
                to right,
                #ffa751,
                #ffe259
            ); /* Chrome 10-25, Safari 5.1-6 */
            background: linear-gradient(
                to right,
                #ffa751,
                #ffe259
            ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

            align-items: center;
            text-align: left;
            gap: 20px;
        `,
        mobileBenefitIcon: css`
            background-color: #dbeafe;
            width: 48px;
            height: 48px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
        `,
        mobileIcon: css`
            width: 24px;
            height: 24px;
            color: #2563eb;
            margin: 0;
        `,
        mobileBenefitTitle: css`
            font-weight: 600;
            color: #1f2937;
            font-size: 0.875rem;
            line-height: 1.25;
        `,
    };

    return (
        <section
            className={benefitsStyles.section}
            id="benefits"
            aria-labelledby="benefits-title"
        >
            <div className={benefitsStyles.container}>
                <div className={benefitsStyles.headerSection}>
                    <h2 className={benefitsStyles.title}>
                        Benefits of the Club Mango Program
                    </h2>

                    {/* Desktop circular layout - hidden on mobile */}
                    {/* <div className={benefitsStyles.logoSection}>
                        <div className={benefitsStyles.centralLogo}>
                            <img
                                src={benefitsLogo}
                                alt="Club Mango Benefits Logo"
                                className={benefitsStyles.logoImage}
                            />
                        </div>

                        <div className={benefitsStyles.benefitsContainer}>
                            {benefits.map((benefit, index) => {
                                const angle = (index * 360) / benefits.length;
                                const radius = 270;
                                const x =
                                    Math.cos(((angle - 90) * Math.PI) / 180) *
                                    radius;
                                const y =
                                    Math.sin(((angle - 90) * Math.PI) / 180) *
                                    radius;

                                return (
                                    <div
                                        key={index}
                                        className={benefitsStyles.benefitItem}
                                        style={{
                                            transform: `translate(${x}px, ${y}px)`,
                                            animationDelay: `${index * 0.1}s`,
                                        }}
                                    >
                                        <div
                                            className={
                                                benefitsStyles.benefitContent
                                            }
                                        >
                                            <div
                                                className={
                                                    benefitsStyles.benefitIcon
                                                }
                                            >
                                                <SafeIcon
                                                    icon={benefit.icon}
                                                    className={
                                                        benefitsStyles.icon
                                                    }
                                                />
                                            </div>
                                            <h3
                                                className={
                                                    benefitsStyles.benefitTitle
                                                }
                                            >
                                                {benefit.title}
                                            </h3>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div> */}

                    <div className={benefitsStyles.benefitsContainerDesktop}>
                        <img src={benefitsDesktop} />
                    </div>

                    {/* Mobile grid layout */}
                    <div className={benefitsStyles.mobileBenefitsGrid}>
                        {benefits.map((benefit, index) => (
                            <div
                                key={index}
                                className={benefitsStyles.mobileBenefitItem}
                            >
                                <div
                                    className={benefitsStyles.mobileBenefitIcon}
                                >
                                    <SafeIcon
                                        icon={benefit.icon}
                                        className={benefitsStyles.mobileIcon}
                                    />
                                </div>
                                <h3
                                    className={
                                        benefitsStyles.mobileBenefitTitle
                                    }
                                >
                                    {benefit.title}
                                </h3>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Benefits;
